import moment from "moment";

/**
 * Convert a Unix timestamp to an ISO 8601 string.
 * @param {number} date
 * @return {string}
 */
const unixToISO = (date) => moment.unix(date).toISOString();

/**
 * Build one of the possible query strings for the SendGrid API:
 * starts from, ends at, or between two dates.
 *
 * @param {Object} payload
 * @return {string}
 */
export const buildGetQuery = (payload) => {
  let query = `to_email='${payload.email}'`;
  const start = payload?.startDate && unixToISO(payload.startDate);
  const end = payload?.endDate && unixToISO(payload.endDate);

  if (start && end) {
    query += ` AND last_event_time BETWEEN TIMESTAMP '${start}' AND TIMESTAMP '${end}'`;
  } else if (start) {
    query += ` AND last_event_time>=TIMESTAMP'${start}'`;
  } else if (end) {
    const end = unixToISO(payload.endDate);
    query += ` AND last_event_time<=TIMESTAMP'${end}'`;
  }

  return query;
};
